import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, " Your work has been auto-saved... ", -1)

import {storeToRefs} from 'pinia';
import { useGrouperStore } from 'stores/grouper-store';


export default /*#__PURE__*/_defineComponent({
  __name: 'AutoSaveBanner',
  setup(__props) {

const { showDraftBanner, bannerDismissed } = storeToRefs(useGrouperStore());


return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_banner = _resolveComponent("q-banner")!

  return _withDirectives((_openBlock(), _createBlock(_component_q_banner, {
    class: "io-mfe-ig-auto-save-banner",
    rounded: "",
    "inline-actions": ""
  }, {
    action: _withCtx(() => [
      _createVNode(_component_q_btn, {
        flat: "",
        unelevated: "",
        onClick: _cache[0] || (_cache[0] = ($event: any) => {showDraftBanner.value = false; bannerDismissed.value = true})
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Dismiss "),
          _createVNode(_component_q_tooltip, null, {
            default: _withCtx(() => [
              _createTextVNode("Dismiss Message")
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createVNode(_component_q_icon, {
        name: "fa-regular fa-circle-check",
        class: "io-mfe-ig-icon-medium"
      }),
      _hoisted_1
    ]),
    _: 1
  }, 512)), [
    [_vShow, _unref(showDraftBanner)]
  ])
}
}

})